export default __webpack_public_path__ + "static/media/other_flag.c7e1da5f.png";